<script lang="ts">
  import { m } from "#messages";
  import { DEMO_PATH } from "#lib/routes.ts";
  import Button from "#lib/ui/Button.svelte";
  import Icon from "#lib/ui/Icon.svelte";

  let { testId = "demo" }: { testId?: string } = $props();
</script>

<Button
  variant="subtle"
  size="lg"
  shape="round"
  href={DEMO_PATH}
  data-sveltekit-reload
  data-testid={testId}
>
  {m.marketing_menu_demo()}
  <Icon name="next" size={16} />
</Button>
